import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=1479529a&lang=pug"
var script = {}
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=1479529a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports